module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/users/new"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать пользователя")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "paging-top"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.usersPage,
      "pagingClass": 'top'
    },
    on: {
      "update:data": function($event) {
        _vm.usersPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow usersTable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.usersPage.content), function(user, index) {
    return _c('tr', [_c('td', {
      staticClass: "userNameCell"
    }, [(user.userId && (user.role !== 'СуперАдминистратор' || _vm.loggedRole === '1' || _vm.loggedRole === 1)) ? _c('a', {
      attrs: {
        "href": '#/users/' + user.id
      }
    }, [_vm._v(_vm._s(user.name))]) : _c('span', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {}, [_c('span', [_vm._v(_vm._s(user.role))])]), _vm._v(" "), _c('td', {}, [_c('span', [_vm._v(_vm._s(user.defaultGateway))])]), _vm._v(" "), _c('td', {
      staticClass: "billingEnable"
    }, [_c('span', {
      class: !!user.billingEnable ? 'enable' : ''
    }, [_vm._v(_vm._s(_vm.getBillingLabel(user.billingEnable)))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadData,
      "per-page": _vm.perPage,
      "data": _vm.usersPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.usersPage = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Имя")]), _vm._v(" "), _c('th', [_vm._v("Роль")]), _vm._v(" "), _c('th', [_vm._v("Шлюз по-умолчанию")]), _vm._v(" "), _c('th', [_vm._v("Биллинг")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bce71ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/users/Users.vue
// module id = 666
// module chunks = 42